// module
import React from 'react';
import { Link } from 'react-router-dom';

const TITLE01 = `GAAP Manual`;

function Manual() {
    window.scrollTo(0,0);
    return(
        <div className="content">
            <h2 className="content_title">{TITLE01}</h2>
            <div className="content_command_box">
                <ul>
                    <li><Link className="manual_link" to="/Gaap01">Sequencing</Link></li>
                    <li><Link className="manual_link" to="/Gaap02">Error correction & Removing duplicate reads</Link></li>
                    <li><Link className="manual_link" to="/Gaap03">Genome assembly</Link></li>
                    <li><Link className="manual_link" to="/Gaap04">Transcriptome assembly</Link></li>
                    <li><Link className="manual_link" to="/Gaap05">Repeat identification</Link></li>
                    <li><Link className="manual_link" to="/Gaap06">Ab initio gene structure prediction</Link></li>
                    <li><Link className="manual_link" to="/Gaap07">Evidence-driven prediction of gene structure</Link></li>
                    <li><Link className="manual_link" to="/Gaap08">Evidence-based consensus gene prediction</Link></li>
                    <li><Link className="manual_link" to="/Gaap09">Post-processing to add UTR annotation</Link></li>
                    <li><Link className="manual_link" to="/Gaap10">Homology search</Link></li>
                    <li><Link className="manual_link" to="/Gaap11">GO term  mapping</Link></li>
                </ul>
            </div>
            <br/><br/><br/><br/>
            <div className="content_buttons_div">
                <Link to="/"><button className="content_button">Home</button></Link>
                <Link to="/Gaap01"><button className="content_button">Next</button></Link>
            </div>
        </div>
    );
}

export default Manual;